import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LoginRoutingModule } from './login-routing.module';
import { LoginComponent } from './login.component';
import {SharedModule} from '../shared/shared.module';
import {FirstComponent} from './first/first.component';
import {PasswordUpdateComponent} from './password-update/password-update.component';
import { LogoCardComponent } from './logo-card/logo-card.component';


@NgModule({
  declarations: [
    LoginComponent, FirstComponent, PasswordUpdateComponent, LogoCardComponent
  ],
  imports: [
    CommonModule,
    LoginRoutingModule,
    SharedModule
  ]
})
export class LoginModule { }
